<template>
  <v-layout row wrap>
    <v-flex>

      <v-slide-y-transition mode="out-in">
        <v-container fluid class="pa-3">
          <v-layout row wrap>
            <v-flex>
              <v-card>
                <v-toolbar dense prominent>
                  <v-toolbar-title>Company Listing</v-toolbar-title>
                  <v-spacer></v-spacer>

                  <v-toolbar-items>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn small fab @click="addNewRecord_onClick()" v-on="on" color="primary">
                          <v-icon>
                            add_circle_outline
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>Add new</span>
                    </v-tooltip>
                  </v-toolbar-items>
                </v-toolbar>

                <v-card-text class="pa-0">
                  <v-container fluid>
                    <v-layout row wrap>
                      <v-expansion-panel>
                        <v-expansion-panel-content class="accent">
                          <template v-slot:header>
                            <div class="subheading">
                              Filter Panel
                            </div>
                          </template>

                          <v-btn color="green" @click="refreshData()"
                            >Generate Now</v-btn
                          >

                          <FilterEditor
                            :query.sync="new_filter"
                            :rules="get_filterable_columns"
                            class="accent"
                          />
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-layout>

                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-data-table
                          id="company_table_id"
                          ref="company_table_ref"
                          :headers="table_setting.headers"
                          :items="table_setting.records"
                          :loading="table_setting.loading"
                          must-sort
                          :pagination.sync="table_setting.pagination"
                          :rows-per-page-items="table_setting.rows_per_page_items"
                          :total-items="table_setting.pagination.totalItems"
                          class="elevation-1"
                        >
                          <v-progress-linear
                            color="blue"
                            indeterminate
                          >
                            <template v-slot:progress>
                            </template>
                          </v-progress-linear>
                          <template v-slot:items="props">
                            <td class="pa-1 pl-3">{{ props.item.id }}</td>
                            <td class="pa-1">{{ props.item.name }}</td>
                            <td class="pa-1">
                              {{ props.item.parent_company__name }}
                            </td>
                            <td class="pa-1">
                              {{
                                convert_2_locale_datetime(props.item.created_date)
                              }}
                            </td>
                            <td class="pa-1">{{ props.item.g_status__value }}</td>
                            <td class="justify-center layout px-0">
                              <v-icon
                                small
                                class="mr-2"
                                color="orange"
                                @click="editRecord_onClick(props.item)"
                              >
                                edit
                              </v-icon>
                            </td>
                          </template>
                        </v-data-table>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>

          <!-- START dialog -->
          <v-dialog
            v-model="dialog.visible"
            persistent
            scrollable
            max-width="600px"
          >
            <v-card>
              <v-card-title class="headline pb-0">
                {{ dialog.title }} Company Record
              </v-card-title>

              <v-card-text>
                <v-form>
                  <v-container grid-list-md class="pa-0">
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-text-field
                          prepend-icon="local_offer"
                          name="name"
                          v-model="selected.name"
                          v-validate="'required|max:100'"
                          :error-messages="errors.first('name')"
                          label="Company Name"
                          type="text"
                        ></v-text-field>
                      </v-flex>

                      <v-flex xs12>
                        <v-select
                          :items="dialog.parent_company_list"
                          v-model="selected.parent_company_id"
                          clearable
                          item-text="name"
                          item-value="id"
                          label="Parent Company"
                          name="parent_company"
                        ></v-select>
                      </v-flex>

                      <v-flex xs12>
                        <v-textarea
                          v-model="selected.desc"
                          name="description"
                          label="Description"
                          hint="Max 1000 characters."
                        ></v-textarea>
                      </v-flex>

                      <v-flex xs12>
                        <v-select
                          :items="status_option"
                          v-model="selected.g_status_id"
                          item-text="value"
                          item-value="id"
                          label="Status"
                          name="status"
                        ></v-select>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-form>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="orange" flat @click="dialog.visible = false">
                  Cancel
                </v-btn>
                <v-btn color="green" flat @click="save_onClick()">
                  Save
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- END dialog -->
        </v-container>
      </v-slide-y-transition>

    </v-flex>
  </v-layout>
</template>

<script>
import common from "../../functions/general";
import qb from "../../functions/query.builder";
import FilterEditor from "../../components/FilterEditor";

export default {
  name: "CompanyListingPage",
  components: {
    FilterEditor: FilterEditor
  },
  data() {
    return {
      new_filter: {
        condition: "and",
        rules: []
      },
      table_setting: {
        loading: false,
        rows_per_page_items: [10, 40, 70, 100],
        headers: [
          {
            text: "ID#",
            value: "id",
            class: "pa-1 pl-3",
            filterable: true,
            data_type: Number
          },
          {
            text: "Company Name",
            class: "pa-1",
            value: "name",
            filterable: true,
            data_type: String
          },
          {
            text: "Parent Company Name",
            class: "pa-1",
            value: "parent_company__name",
            filterable: true,
            data_type: String
          },
          {
            text: "Created DateTime",
            align: "left",
            class: "pa-1",
            value: "created_date",
            filterable: true,
            data_type: Number
          },
          {
            text: "Status",
            align: "left",
            class: "pa-1",
            value: "g_status__value",
            filterable: true,
            data_type: String
          },
          {
            text: "",
            value: "a_actions",
            class: "pa-1",
            filterable: false,
            data_type: Number
          }
        ],
        records: [],
        pagination: {
          descending: false,
          page: 1,
          rowsPerPage: 10,
          sortBy: "name",
          totalItems: 0
        }
      },
      status_option: [],
      dialog: {
        visible: false,
        title: "",
        parent_company_list: []
      },
      selected: {
        id: "",
        name: "",
        parent_company_id: "",
        g_status_id: "",
        desc: ""
      }
    };
  },
  computed: {
    get_filterable_columns() {
      var return_value = this.table_setting.headers.filter(
        rec => rec.filterable == true
      );
      return return_value;
    }
  },
  watch: {
    "table_setting.pagination": {
      handler: function() {
        this.refreshData();
      },
      deep: true
    }
  },
  async mounted() {
    this.status_option = await common.App.getGeneralOptions(
      "General",
      "status",
      ["id", "value"]
    );

    //this.refreshData();
  },
  methods: {
    convert_2_locale_datetime(date) {
      return common.App.to_locale_datetime(date);
    },
    async refreshData() {
      let cls_qb = new qb.QueryBuilder();

      cls_qb.Method = "all";

      cls_qb.Select = [
        "id",
        "name",
        "g_status_id",
        "g_status__value",
        "parent_company_id",
        "parent_company__name",
        "created_date",
        "desc"
      ];

      cls_qb.Where = this.new_filter;

      if (this.table_setting.pagination.rowsPerPage > 0) {
        cls_qb.Offset =
          (this.table_setting.pagination.page - 1) *
          this.table_setting.pagination.rowsPerPage;
        cls_qb.Limit = this.table_setting.pagination.rowsPerPage;
      }

      cls_qb.Order = [
        this.table_setting.pagination.descending
          ? "-" + this.table_setting.pagination.sortBy
          : this.table_setting.pagination.sortBy
      ];

      let result = await common.wBackEndComm.PostData(
        "company/company_listing/",
        cls_qb
      );

      if (result.data.Status == 1) {
        this.table_setting.records = result.data.Body.records;

        this.table_setting.pagination.totalItems =
          result.data.Body.total_records_after_filtered;

        this.dialog.parent_company_list = result.data.Body.records;
      } else {
        common.wMsgBox.Error(result.data.Description);
      }
    },
    editRecord_onClick(item) {
      this.dialog.visible = true;
      this.dialog.title = "Modifying ";

      this.$validator.reset();

      this.selected = {
        id: item["id"],
        name: item["name"],
        g_status_id: item["g_status_id"],
        parent_company_id: item["parent_company_id"],
        desc: item["desc"]
      };
    },
    addNewRecord_onClick() {
      this.dialog.visible = true;
      this.dialog.title = "Create";

      this.$validator.reset();

      this.selected = {
        id: "",
        name: "",
        g_status_id: this.status_option[0].id,
        parent_company_id: "",
        desc: ""
      };
    },
    save_onClick() {
      let self = this;

      this.$validator.validateAll().then(async result => {
        if (result) {
          let result = await common.wBackEndComm.PostData(
            "company/crud_company/",
            self.selected
          );

          if (result.data.Status == 1) {
            self.dialog.visible = false;
            self.refreshData();
            common.wMsgBox.Success(result.data.Description);
          } else {
            common.wMsgBox.Error(result.data.Description);
          }
        }
      });
    }
  }
};
</script>

<style>
</style>
